/**
 * 埋め込みプレーヤの URL とプレーヤ制御メッセージ（EP-2・M7b）。
 *
 * サーバ（`Overlay\OverlayInput`）は provider ＋ 動画 ID だけを持ち、埋め込み URL の
 * 組み立てはここに閉じる（外部 SDK は読み込まない — バンドルを増やさず CSP も広げない）。
 * ID の取り出しはサーバ側で済んでいるので、ここは ID → URL の一方向だけを担う。
 *
 * 一時停止は iframe への postMessage で送る（YouTube IFrame API / Vimeo Player API の
 * どちらも SDK 無しで受け付ける最小のメッセージ）。**実挙動は実機で要検証**だが、効かなくても
 * 要素は破棄されないためリロードは起きない。
 */

/** provider（自前ホストを除く）。 */
export type EmbedProvider = 'youtube' | 'vimeo';

/**
 * 埋め込み URL（クリックでマウントする iframe の src）。
 * autoplay を付けるのは「ユーザーのクリックで初めてマウントする」ため
 * （自動再生ポリシーはユーザー操作直後の再生を許す）。
 */
export function embedUrl(provider: EmbedProvider, id: string): string {
  if (provider === 'youtube') {
    return `https://www.youtube.com/embed/${encodeURIComponent(id)}?enablejsapi=1&rel=0&autoplay=1`;
  }
  return `https://player.vimeo.com/video/${encodeURIComponent(id)}?autoplay=1`;
}

/** iframe の origin（postMessage の targetOrigin に使う）。 */
export function embedOrigin(provider: EmbedProvider): string {
  return provider === 'youtube' ? 'https://www.youtube.com' : 'https://player.vimeo.com';
}

/** 一時停止を伝える postMessage 本文（SDK 無しで受け付く最小メッセージ）。 */
export function pauseMessage(provider: EmbedProvider): string {
  return provider === 'youtube'
    ? JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] })
    : JSON.stringify({ method: 'pause' });
}
